let currentModal = null

export default function (Alpine) {
  Alpine.data('modal', function (modalName, scope = {}) {
    const modalContext = {
      ...scope,
      modalName,
      data: {},
      isOpen: false,
      open(data) {
        this.data = data
        this.isOpen = true
        if (currentModal && currentModal !== this.modalName) {
          Alpine.store('modal_' + currentModal).close()
        }
        currentModal = this.modalName
        this.$nextTick(() => {
          let toFocus = this.$el.querySelector('[autofocus]')
          toFocus && this.$focus.focus(toFocus)
          this.$el.dispatchEvent(new CustomEvent('modal-opened'))
          window.dispatchEvent(
            new CustomEvent(`modal-${this.modalName}-opened`)
          )
        })
      },
      close() {
        this.data = {}
        this.isOpen = false
        if (currentModal === this.modalName) {
          currentModal = null
        }
        this.$nextTick(() => {
          this.$el.dispatchEvent(new CustomEvent('modal-closed'))
          window.dispatchEvent(
            new CustomEvent(`modal-${this.modalName}-closed`)
          )
        })
      },
      toggle() {
        if (this.isOpen) {
          this.close()
        } else {
          this.open()
        }
      },
    }

    Alpine.store('modal_' + modalName, modalContext)

    return modalContext
  })
}
